/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * describes the status of a voucher
 * @export
 */
export const VoucherStatus = {
    Available: 'AVAILABLE',
    Redeemed: 'REDEEMED'
} as const;
export type VoucherStatus = typeof VoucherStatus[keyof typeof VoucherStatus];


export function VoucherStatusFromJSON(json: any): VoucherStatus {
    return VoucherStatusFromJSONTyped(json, false);
}

export function VoucherStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherStatus {
    return json as VoucherStatus;
}

export function VoucherStatusToJSON(value?: VoucherStatus | null): any {
    return value as any;
}

